import firebase from 'firebase/compat/app';
import 'firebase/compat/messaging';

// Configs
import { environment } from '@environments/environment';

firebase.initializeApp(environment.firebase);
export const messaging = firebase.messaging();
